import { MutableRefObject, useEffect, useRef, useState } from 'react'

export const useTextMaxWidth = (correction: number = 120): {
  containerRef: MutableRefObject<HTMLButtonElement>
  maxWidth: number
} => {
  const containerRef = useRef<HTMLButtonElement>()
  const [maxWidth, setMaxWidth] = useState<number>()

  useEffect(() => {
    if (!containerRef?.current?.clientWidth) return

    setMaxWidth(containerRef.current.clientWidth - correction)
  }, [containerRef, correction])

  return {
    containerRef,
    maxWidth
  }
}
